function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrisesAndDisasters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.098,3.51L1.098,4.552C1.098,5.864 1.229,7.16 1.482,8.417L28.535,8.417C28.78,7.888 29.11,7.397 29.531,6.976L32.491,4.016C32.813,3.694 32.997,3.249 32.997,2.789C32.997,1.83 32.223,1.056 31.264,1.056L3.552,1.056C2.195,1.056 1.098,2.152 1.098,3.51ZM28.105,10.871L2.141,10.871C3.077,13.624 4.618,16.139 6.65,18.232L32.691,18.232L29.071,13.409C28.512,12.665 28.182,11.784 28.105,10.871ZM10.775,21.468L19.701,26.721C20.33,27.089 20.913,27.541 21.426,28.048L35.221,28.048C35.375,27.296 35.451,26.522 35.451,25.739C35.451,23.976 35.045,22.25 34.278,20.686L9.548,20.686C9.947,20.962 10.354,21.223 10.775,21.468ZM23.182,30.501C23.972,32.142 24.24,33.99 23.941,35.792L23.489,38.53C23.336,39.465 24.056,40.324 25.007,40.324C25.414,40.324 25.805,40.163 26.096,39.872L32.093,33.875C33.074,32.894 33.864,31.751 34.424,30.509L23.182,30.509L23.182,30.501Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrisesAndDisasters);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crises-and-disasters.c697d84b524acc87680838bd00bca137.svg";